export default __webpack_public_path__ + "static/media/background.a13ac3bb.gif";